import type { DamageType } from "../damageType";
import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { Thing } from "../thing";
import type { XY } from "../xy";
import { Fire } from "./fire";
import { Sound } from "./sounds/sound";
import { SoundId } from "./sounds/soundId";

export class FireTower extends DestroyableObstacle {
	static key = "FireTower";

	getDebrisParticleType(): ParticleType {
		return ParticleType.ROCK_DEBRIS;
	}

	protected onZeroHp(source: Thing | null, type: DamageType | null): void {
		this.board!.addNonPhysicalThing(new Sound(SoundId.ROCK_BREAK, this.xy));
		this.board!.addThing(new Fire(this.xy));
		super.onZeroHp(source, type);
	}

	static deserialize(data: any): FireTower {
		const f = new FireTower(deserializeXY(data.xy));
		f.restoreBaseFields(data);
		return f;
	}
}
